import React from 'react';
import { default as Flag, AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import { useSharedState } from '@trello/shared-state';
import { flagsState } from './flagsState';
import { dismissFlag } from './showFlag';

// The FlagGroup component renders its children in a Portal, and is opinionated
// about the shape of its children (with nth-child selectors et al), so we need
// to be able to reference it with a DOM selector for layering.
export const FLAG_GROUP_SELECTOR = 'div[class$="FlagGroup"]';

export const Flags: React.FunctionComponent = () => {
  const [flags] = useSharedState(flagsState);
  return (
    <FlagGroup onDismissed={dismissFlag}>
      {flags.map((flag) => {
        const { isAutoDismiss, ...restProps } = flag;
        const FlagType = isAutoDismiss ? AutoDismissFlag : Flag;
        return <FlagType key={flag.id} {...restProps} />;
      })}
    </FlagGroup>
  );
};
